import { render, staticRenderFns } from "./LTA.vue?vue&type=template&id=db0699d4&scoped=true"
import script from "./LTA.vue?vue&type=script&lang=js"
export * from "./LTA.vue?vue&type=script&lang=js"
import style0 from "./LTA.vue?vue&type=style&index=0&id=db0699d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0699d4",
  null
  
)

export default component.exports